export default "__VITE_ASSET__8d3f7f42__"